import React, { useContext } from 'react';
import styled from 'styled-components';
import DashboardCardLeft from './DashboardCardLeftOneCol';
import { BodyText } from 'common/styles/page';
import { useNavigate } from 'react-router';
import { AIPromptButtons } from 'areas/copilot/components/CopilotPromptButtons';
import { TopBarContext } from 'common/layouts/AuthLayout/TopBarContext';

import { useApiPortalV1AssessmentsResultsListQuery } from 'areas/assessment-schedule/api';
import { BulletListFormatter } from 'common/utils/AIUtils';

import { AggregateType } from 'common/constants/AggregateType';
interface DashboardCopilotLeftProps {
  assessment_period_id: number;
}

const DashboardCopilotLeft = ({ assessment_period_id }: DashboardCopilotLeftProps) => {
  const navigate = useNavigate();
  const { openCopilot } = useContext(TopBarContext);

  const { data: ai_sentiment_data } = useApiPortalV1AssessmentsResultsListQuery({
    aggregateType: AggregateType.AI_SUMMARY_ORGANIZATION,
    assessmentPeriodId: assessment_period_id,
  });

  const handleStartConversation = () => {
    if (openCopilot) {
      openCopilot();
      return;
    }

    navigate('/app/copilot/');
  };

  return (
    <DashboardCardLeft
      title="Culture Summary"
      content={
        <Container>
          <ScrollableDiv>
            {ai_sentiment_data && (
              <>
                <BodyText>{ai_sentiment_data?.[0]?.result?.summary}</BodyText>
                <BodyText>{BulletListFormatter(ai_sentiment_data?.[0]?.result?.bullets)}</BodyText>
              </>
            )}
          </ScrollableDiv>
          <Row>
            <Title>Culture Copilot</Title>
          </Row>
          <Row>
            <HoverableText onClick={handleStartConversation}>
              Start a conversation about your data!
            </HoverableText>
          </Row>
        </Container>
      }
    />
  );
};
export default DashboardCopilotLeft;

// Styled components
const ScrollableDiv = styled.div`
  height: 230px;
  overflow-y: auto;
  padding: 0.5rem;
`;

const Row = styled.div`
  display: flex;
  gap: 14px;
  align-items: center;
`;

const Title = styled.div`
  font-family: 'Poppins', sans-serif;
  font-size: 14px;
  font-weight: bold;
  color: #333;
`;

const HoverableText = styled.div`
  padding: 12px 10px;
  border: 1px solid rgba(165, 207, 238, 0.75);
  border-radius: 4px;
  font-family: 'Poppins', sans-serif;
  font-size: 13px;
  color: #0f172a;
  background-color: rgba(165, 207, 238, 0.24);
  font-weight: 600;
  cursor: pointer;
  text-align: center;
  user-select: none;
  flex: 1; /* Ensures all items have equal width */

  &:hover {
    background-color: rgba(165, 207, 238, 0.35);
  }
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex: 1;
`;

export const Caption = styled.div`
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  display: block;
  max-width: 200px;
  color: #777;

  display: inline-block;
  width: 100%;
  max-width: 100%;

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

